// GENERATED by scripts/build-pincode-data.py -- do not edit by hand.
// The 36 States / Union Territories (28 + 8; LGD, https://lgdirectory.gov.in/). These are the
// exact State strings written into public/pincode/*.json.
export const INDIA_STATES = Object.freeze([
  'Andaman and Nicobar Islands',
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chandigarh',
  'Chhattisgarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Ladakh',
  'Lakshadweep',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Puducherry',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
]);

// Other spellings -> canonical name (key: lower case, "&" -> "and", single spaces). Same table
// as the backend app/utils/india_states.py _STATE_ALIASES; read via canonicalState().
export const INDIA_STATE_ALIASES = Object.freeze({
  'andaman and nico.in.': 'Andaman and Nicobar Islands',
  'chattisgarh': 'Chhattisgarh',
  'dadra and nagar hav.': 'Dadra and Nagar Haveli and Daman and Diu',
  'dadra and nagar haveli': 'Dadra and Nagar Haveli and Daman and Diu',
  'daman and diu': 'Dadra and Nagar Haveli and Daman and Diu',
  'megalaya': 'Meghalaya',
  'nct of delhi': 'Delhi',
  'new delhi': 'Delhi',
  'pondicherry': 'Puducherry',
  'the dadra and nagar haveli and daman and diu': 'Dadra and Nagar Haveli and Daman and Diu',
});
